<template>
   <v-footer
      color="#46659B"
      app
      inset
    >
      <v-spacer></v-spacer>
      <span class="white--text">&copy;Blú Capital 2020</span>
    </v-footer>
</template>

<script>

export default {
  name: 'TheFooter',

  data: () => ({
    //
  })
}
</script>
